import { FunctionField, ListProps, TextField } from 'react-admin';

import {
  TextInput,
  Grid,
  GridList,
  BooleanField,
  ManyField,
  Forbidden,
  DateField,
} from '@components';
import { useRbacList } from '@hooks';
import { AdminRole } from '@types';
import cls from './RoleList.module.css';
import React from 'react';

const AreasList = ({ data }: { data: AdminRole}): JSX.Element => (
  data.areas.length
    ? <>
      {data.areas.map(a => (
        <span className={cls.chip} key={a.id}>{a.name}</span>
      ))}
    </>
    : <></>
);

export const RoleList = (props: ListProps) => {
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Grid
        rowClick="edit"
        className={cls.grid}
        defaultColumns={'id name permissions isEnabled createdAt'.split(' ')}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" label="Name" />
        <ManyField source="permissions" reference="permission" label="Permissions" isColumn={false} sortable={false} />
        <BooleanField source="isEnabled" label="Is Enabled" />
        <DateField source="createdAt" showTime label="Created At" />
        <FunctionField source="areas" sortBy="areas" label="Default Area" render={(r: AdminRole) => (
          <AreasList data={r} />
        )} />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" variant="outlined" label="Search" alwaysOn />,
];
